import axios from "axios";
import { remove } from "local-storage";
const baseUrl = process.env.REACT_APP_APIURL;

const axiosTeethTab = axios.create({
  baseURL: baseUrl,
});

export const setAuthToken = (token: string | null) => {
  if (token) {
    axiosTeethTab.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axiosTeethTab.defaults.headers.common["Authorization"];
  }
};

// A 401 means the token is invalid/expired or the user account was
// deactivated server-side. Either way, force a logout so a deactivated
// user is kicked out on their very next request instead of staying
// logged in with a stale session.
axiosTeethTab.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      remove("userData");
      setAuthToken(null);
      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  },
);

export default axiosTeethTab;
